<template>
	<v-app>
		<NavBar />
		<v-main class="ma-4">
			<h1>{{ this.$store.state.user.firstname }}</h1>
			<Charts />
		</v-main>
	</v-app>
</template>

<script>
import axios from "axios";
import NavBar from "@/components/NavBar";
import Charts from "@/components/Charts.vue";
import { mapState } from "vuex";

export default {
	components: {
		NavBar,
		Charts,
	},
	computed: {
		...mapState({
			token: "token",
		}),
	},
	methods: {
		onClick() {
			axios.get(process.env.VUE_APP_BACKEND_URL + "/test", {
				headers: {
					Authorization: "bearer " + this.token,
				},
			});
		},
	},
};
</script>

<style></style>
